var building_developers = {
  building_developers: {
    1: {
    id: "1",
    name: "4 Ever Home Properties",
    website: null,
    description: null
    },
    2: {
    id: "2",
    name: "Abitare Holdings Ltd",
    website: null,
    description: null
    },
    3: {
    id: "3",
    name: "Abstract Developments Inc.",
    website: null,
    description: null
    },
    4: {
    id: "4",
    name: "Adera",
    website: null,
    description: null
    },
    5: {
    id: "5",
    name: "Adera Group",
    website: null,
    description: null
    },
    6: {
    id: "6",
    name: "ALDEA HOMES LTD",
    website: null,
    description: null
    },
    7: {
    id: "7",
    name: "Algra Bros",
    website: null,
    description: null
    },
    8: {
    id: "8",
    name: "Allaire Group",
    website: null,
    description: null
    },
    9: {
    id: "9",
    name: "Alpha Beta Developments Ltd.",
    website: null,
    description: null
    },
    10: {
    id: "10",
    name: "Alpha Project Development Ltd.",
    website: null,
    description: null
    },
    11: {
    id: "11",
    name: "ALTA Group of Companies",
    website: null,
    description: null
    },
    12: {
    id: "12",
    name: "ALTUS GROUP",
    website: null,
    description: null
    },
    13: {
    id: "13",
    name: "Am-Pri",
    website: null,
    description: null
    },
    14: {
    id: "14",
    name: "Am-Pri Construction Ltd.",
    website: null,
    description: null
    },
    15: {
    id: "15",
    name: "AMA Development Corp",
    website: null,
    description: null
    },
    16: {
    id: "16",
    name: "Amacon",
    website: null,
    description: null
    },
    17: {
    id: "17",
    name: "Ambros",
    website: null,
    description: null
    },
    18: {
    id: "18",
    name: "Anderson Square Holdings Ltd.",
    website: null,
    description: null
    },
    19: {
    id: "19",
    name: "Ansu Developments",
    website: null,
    description: null
    },
    20: {
    id: "20",
    name: "Anthem Properties",
    website: null,
    description: null
    },
    21: {
    id: "21",
    name: "Apex Custom Homes Ltd",
    website: null,
    description: null
    },
    22: {
    id: "22",
    name: "Apolla Development",
    website: null,
    description: null
    },
    23: {
    id: "23",
    name: "Appia Developments Ltd.",
    website: null,
    description: null
    },
    24: {
    id: "24",
    name: "Appia Group",
    website: null,
    description: null
    },
    25: {
    id: "25",
    name: "Aquattro Development",
    website: null,
    description: null
    },
    26: {
    id: "26",
    name: "Aquila Developments",
    website: null,
    description: null
    },
    27: {
    id: "27",
    name: "Aquilini Development and Construction Inc.",
    website: null,
    description: null
    },
    28: {
    id: "28",
    name: "Aquilini Investment Group",
    website: null,
    description: null
    },
    29: {
    id: "29",
    name: "ARA VENTURES INC",
    website: null,
    description: null
    },
    30: {
    id: "30",
    name: "Aragon Properties Ltd",
    website: null,
    description: null
    },
    31: {
    id: "31",
    name: "Archstone Projects Ltd.",
    website: null,
    description: null
    },
    32: {
    id: "32",
    name: "AREE Holdings Ltd.",
    website: null,
    description: null
    },
    33: {
    id: "33",
    name: "Arthur Bell Holdings Ltd.",
    website: null,
    description: null
    },
    34: {
    id: "34",
    name: "Artisan Park Properties Ltd.",
    website: null,
    description: null
    },
    35: {
    id: "35",
    name: "Aspac Developments Ltd.",
    website: null,
    description: null
    },
    36: {
    id: "36",
    name: "Athenry Development Limited",
    website: null,
    description: null
    },
    37: {
    id: "37",
    name: "ATI Investment Ltd.",
    website: null,
    description: null
    },
    38: {
    id: "38",
    name: "Ayen Group",
    website: null,
    description: null
    },
    39: {
    id: "39",
    name: "Ballenas Project Management",
    website: null,
    description: null
    },
    40: {
    id: "40",
    name: "Barber Creek Development Ltd",
    website: null,
    description: null
    },
    41: {
    id: "41",
    name: "Barco Canada Development",
    website: null,
    description: null
    },
    42: {
    id: "42",
    name: "Bastion Development Corporation",
    website: null,
    description: null
    },
    43: {
    id: "43",
    name: "Beach Avenue Developments",
    website: null,
    description: null
    },
    44: {
    id: "44",
    name: "Bear Mountain Master Partnership",
    website: null,
    description: null
    },
    45: {
    id: "45",
    name: "Beedie Living",
    website: null,
    description: null
    },
    46: {
    id: "46",
    name: "Benchmark Homes Ltd.",
    website: null,
    description: null
    },
    47: {
    id: "47",
    name: "Bentall Real Estate Services",
    website: null,
    description: null
    },
    48: {
    id: "48",
    name: "Bestbuy Development Ltd",
    website: null,
    description: null
    },
    49: {
    id: "49",
    name: "Bill's Development Ltd",
    website: null,
    description: null
    },
    50: {
    id: "50",
    name: "Blexo Developments",
    website: null,
    description: null
    },
    51: {
    id: "51",
    name: "Blue Tree Management (Canada) Limited",
    website: null,
    description: null
    },
    52: {
    id: "52",
    name: "BlueSky Properties",
    website: null,
    description: null
    },
    53: {
    id: "53",
    name: "Bluetree Homes",
    website: null,
    description: null
    },
    54: {
    id: "54",
    name: "Boffo Bros Development Ltd.",
    website: null,
    description: null
    },
    55: {
    id: "55",
    name: "Boffo Developments Ltd.",
    website: null,
    description: null
    },
    56: {
    id: "56",
    name: "Bogner Development Group Ltd",
    website: null,
    description: null
    },
    57: {
    id: "57",
    name: "Bogner Development Group Ltd;",
    website: null,
    description: null
    },
    58: {
    id: "58",
    name: "Bonnis Development Corp.",
    website: null,
    description: null
    },
    59: {
    id: "59",
    name: "Bosa Development",
    website: null,
    description: null
    },
    60: {
    id: "60",
    name: "Bosa Properties",
    website: null,
    description: null
    },
    61: {
    id: "61",
    name: "Breeze Properties Ltd.",
    website: null,
    description: null
    },
    62: {
    id: "62",
    name: "Brentwood Bay Lodge Ltd.",
    website: null,
    description: null
    },
    63: {
    id: "63",
    name: "British Pacific Properties",
    website: null,
    description: null
    },
    64: {
    id: "64",
    name: "Brody Development Group",
    website: null,
    description: null
    },
    65: {
    id: "65",
    name: "Bronte Heights Development",
    website: null,
    description: null
    },
    66: {
    id: "66",
    name: "Brookside Walk Holdings Ltd.,",
    website: null,
    description: null
    },
    67: {
    id: "67",
    name: "Bucci Developments Ltd.",
    website: null,
    description: null
    },
    68: {
    id: "68",
    name: "Buset Development Corp.",
    website: null,
    description: null
    },
    69: {
    id: "69",
    name: "Cal-Terra Developments",
    website: null,
    description: null
    },
    70: {
    id: "70",
    name: "Canada Lands Company",
    website: null,
    description: null
    },
    71: {
    id: "71",
    name: "Casa Mia Projects Ltd",
    website: null,
    description: null
    },
    72: {
    id: "72",
    name: "Cascadia Development Corporation",
    website: null,
    description: null
    },
    73: {
    id: "73",
    name: "CastleHill Homes",
    website: null,
    description: null
    },
    74: {
    id: "74",
    name: "Casula Investment Ltd.",
    website: null,
    description: null
    },
    75: {
    id: "75",
    name: "CCM Investment Group Ltd.",
    website: null,
    description: null
    },
    76: {
    id: "76",
    name: "Cedar Developments Corporation",
    website: null,
    description: null
    },
    77: {
    id: "77",
    name: "Censorio Group of Companies",
    website: null,
    description: null
    },
    78: {
    id: "78",
    name: "Centro Parkside Development Ltd.",
    website: null,
    description: null
    },
    79: {
    id: "79",
    name: "Century Group",
    website: null,
    description: null
    },
    80: {
    id: "80",
    name: "Chandler Development Group Inc.",
    website: null,
    description: null
    },
    81: {
    id: "81",
    name: "Charan Sethi",
    website: null,
    description: null
    },
    82: {
    id: "82",
    name: "Chard Developments",
    website: null,
    description: null
    },
    83: {
    id: "83",
    name: "Charland Homes LP",
    website: null,
    description: null
    },
    84: {
    id: "84",
    name: "Citimark",
    website: null,
    description: null
    },
    85: {
    id: "85",
    name: "City LifeStyle Group",
    website: null,
    description: null
    },
    86: {
    id: "86",
    name: "Claravista Homes Ltd.",
    website: null,
    description: null
    },
    87: {
    id: "87",
    name: "Clay Group",
    website: null,
    description: null
    },
    88: {
    id: "88",
    name: "Coast 49 Homes Ltd.",
    website: null,
    description: null
    },
    89: {
    id: "89",
    name: "Colliers International",
    website: null,
    description: null
    },
    90: {
    id: "90",
    name: "Concert Properties Ltd.",
    website: null,
    description: null
    },
    91: {
    id: "91",
    name: "Concord Pacific",
    website: null,
    description: null
    },
    92: {
    id: "92",
    name: "ConEcon Consultants Inc.",
    website: null,
    description: null
    },
    93: {
    id: "93",
    name: "Coniston Developments Ltd.",
    website: null,
    description: null
    },
    94: {
    id: "94",
    name: "Cornerstone Construction Ltd.",
    website: null,
    description: null
    },
    95: {
    id: "95",
    name: "Cressey Development Group",
    website: null,
    description: null
    },
    96: {
    id: "96",
    name: "CYCLAMEN TRADE CO LTD",
    website: null,
    description: null
    },
    97: {
    id: "97",
    name: "Dallas Point Developments",
    website: null,
    description: null
    },
    98: {
    id: "98",
    name: "Dams Development Corporation",
    website: null,
    description: null
    },
    99: {
    id: "99",
    name: "Darwin Construction Ltd",
    website: null,
    description: null
    },
    100: {
    id: "100",
    name: "Dava Developments",
    website: null,
    description: null
    },
    101: {
    id: "101",
    name: "Dawson + Sawyer",
    website: null,
    description: null
    },
    102: {
    id: "102",
    name: "DCM Projects Ltd",
    website: null,
    description: null
    },
    103: {
    id: "103",
    name: "De Cotiis Group",
    website: null,
    description: null
    },
    104: {
    id: "104",
    name: "Decorus Development Inc",
    website: null,
    description: null
    },
    105: {
    id: "105",
    name: "Degelder Group",
    website: null,
    description: null
    },
    106: {
    id: "106",
    name: "Delta Blue Construction Inc.",
    website: null,
    description: null
    },
    107: {
    id: "107",
    name: "Delta Land Development Ltd",
    website: null,
    description: null
    },
    108: {
    id: "108",
    name: "Denford Construction Management Ltd.﻿",
    website: null,
    description: null
    },
    109: {
    id: "109",
    name: "Denna Homes",
    website: null,
    description: null
    },
    110: {
    id: "110",
    name: "Dennis Rogers",
    website: null,
    description: null
    },
    111: {
    id: "111",
    name: "Diamond Robinson Group Ltd",
    website: null,
    description: null
    },
    112: {
    id: "112",
    name: "Dimex Group",
    website: null,
    description: null
    },
    113: {
    id: "113",
    name: "DMRC Properties Ltd.",
    website: null,
    description: null
    },
    114: {
    id: "114",
    name: "Don Mann Excavating Ltd.",
    website: null,
    description: null
    },
    115: {
    id: "115",
    name: "Doon Developments",
    website: null,
    description: null
    },
    116: {
    id: "116",
    name: "DR4 Developments Ltd.",
    website: null,
    description: null
    },
    117: {
    id: "117",
    name: "DTKH Robson Development Ltd.",
    website: null,
    description: null
    },
    118: {
    id: "118",
    name: "Dueck General Contracting",
    website: null,
    description: null
    },
    119: {
    id: "119",
    name: "Dymax Development Corp",
    website: null,
    description: null
    },
    120: {
    id: "120",
    name: "Eccom Developments Ltd.",
    website: null,
    description: null
    },
    121: {
    id: "121",
    name: "Eclissi Developments Ltd.",
    website: null,
    description: null
    },
    122: {
    id: "122",
    name: "Elegant Development Inc.",
    website: null,
    description: null
    },
    123: {
    id: "123",
    name: "Elite Homes",
    website: null,
    description: null
    },
    124: {
    id: "124",
    name: "Emaar Properties (Canada) Ltd.",
    website: null,
    description: null
    },
    125: {
    id: "125",
    name: "Embassy Development Corporation",
    website: null,
    description: null
    },
    126: {
    id: "126",
    name: "Empire Developments",
    website: null,
    description: null
    },
    127: {
    id: "127",
    name: "EPIX Developments Ltd.",
    website: null,
    description: null
    },
    128: {
    id: "128",
    name: "EPS Westcoast Construction Ltd.",
    website: null,
    description: null
    },
    129: {
    id: "129",
    name: "Epta Properties",
    website: null,
    description: null
    },
    130: {
    id: "130",
    name: "Equitas",
    website: null,
    description: null
    },
    131: {
    id: "131",
    name: "Ernest & Twins Developments Inc.",
    website: null,
    description: null
    },
    132: {
    id: "132",
    name: "Ethos Developments LTD",
    website: null,
    description: null
    },
    133: {
    id: "133",
    name: "Executive Group Development",
    website: null,
    description: null
    },
    134: {
    id: "134",
    name: "Executive Group of Company",
    website: null,
    description: null
    },
    135: {
    id: "135",
    name: "Extol Developments",
    website: null,
    description: null
    },
    136: {
    id: "136",
    name: "Fairborne Homes",
    website: null,
    description: null
    },
    137: {
    id: "137",
    name: "Falcon Homes",
    website: null,
    description: null
    },
    138: {
    id: "138",
    name: "Fidelity Development Ltd.",
    website: null,
    description: null
    },
    139: {
    id: "139",
    name: "FireLight Developments Ltd.",
    website: null,
    description: null
    },
    140: {
    id: "140",
    name: "FIRM Development Ltd",
    website: null,
    description: null
    },
    141: {
    id: "141",
    name: "First Western Developments Ltd.",
    website: null,
    description: null
    },
    142: {
    id: "142",
    name: "Flame Engineering and Construction",
    website: null,
    description: null
    },
    143: {
    id: "143",
    name: "Focus Equities",
    website: null,
    description: null
    },
    144: {
    id: "144",
    name: "Fortuna Development Inc",
    website: null,
    description: null
    },
    145: {
    id: "145",
    name: "Four Sons Enterprises Ltd",
    website: null,
    description: null
    },
    146: {
    id: "146",
    name: "Foxridge Homes",
    website: null,
    description: null
    },
    147: {
    id: "147",
    name: "G3 Developments",
    website: null,
    description: null
    },
    148: {
    id: "148",
    name: "Galiano Enterprises Ltd.",
    website: null,
    description: null
    },
    149: {
    id: "149",
    name: "Garcha Properties Ltd.",
    website: null,
    description: null
    },
    150: {
    id: "150",
    name: "Gardenia Homes LTD.",
    website: null,
    description: null
    },
    151: {
    id: "151",
    name: "Gem Garden Homes Ltd.",
    website: null,
    description: null
    },
    152: {
    id: "152",
    name: "Genesis Tower Ltd.",
    website: null,
    description: null
    },
    153: {
    id: "153",
    name: "Genex Development Corporation",
    website: null,
    description: null
    },
    154: {
    id: "154",
    name: "Genica Development",
    website: null,
    description: null
    },
    155: {
    id: "155",
    name: "Georgia Laine Developments Ltd",
    website: null,
    description: null
    },
    156: {
    id: "156",
    name: "Golden City Homes Ltd.",
    website: null,
    description: null
    },
    157: {
    id: "157",
    name: "Gord Dhillon",
    website: null,
    description: null
    },
    158: {
    id: "158",
    name: "Gore Brothers' Homes",
    website: null,
    description: null
    },
    159: {
    id: "159",
    name: "Graham Group Ltd.",
    website: null,
    description: null
    },
    160: {
    id: "160",
    name: "Gramercy Group",
    website: null,
    description: null
    },
    161: {
    id: "161",
    name: "Grand Adex Development",
    website: null,
    description: null
    },
    162: {
    id: "162",
    name: "Granville Westside Developments Ltd",
    website: null,
    description: null
    },
    163: {
    id: "163",
    name: "Great West Development",
    website: null,
    description: null
    },
    164: {
    id: "164",
    name: "Greci Developments",
    website: null,
    description: null
    },
    165: {
    id: "165",
    name: "Grosvenor Americas",
    website: null,
    description: null
    },
    166: {
    id: "166",
    name: "Group Pacific Developments",
    website: null,
    description: null
    },
    167: {
    id: "167",
    name: "Guildford Brook Estates Development Corporation",
    website: null,
    description: null
    },
    168: {
    id: "168",
    name: "H.j. Property Investment",
    website: null,
    description: null
    },
    169: {
    id: "169",
    name: "Haebler Construction",
    website: null,
    description: null
    },
    170: {
    id: "170",
    name: "Hans de Goede Development Ltd.",
    website: null,
    description: null
    },
    171: {
    id: "171",
    name: "Harbourview",
    website: null,
    description: null
    },
    172: {
    id: "172",
    name: "Hastings Sunrise Development Limited",
    website: null,
    description: null
    },
    173: {
    id: "173",
    name: "Hayer Builders Group",
    website: null,
    description: null
    },
    174: {
    id: "174",
    name: "Hayer Homes Ltd.",
    website: null,
    description: null
    },
    175: {
    id: "175",
    name: "Hazelnut Homes",
    website: null,
    description: null
    },
    176: {
    id: "176",
    name: "Hazelwood Holdings Ltd.",
    website: null,
    description: null
    },
    177: {
    id: "177",
    name: "HCH Land Co Ltd.",
    website: null,
    description: null
    },
    178: {
    id: "178",
    name: "Heatherbrae Construction",
    website: null,
    description: null
    },
    179: {
    id: "179",
    name: "Henderson Development (Canada) Ltd.",
    website: null,
    description: null
    },
    180: {
    id: "180",
    name: "Hesco Properties",
    website: null,
    description: null
    },
    181: {
    id: "181",
    name: "Hillside Development Ltd",
    website: null,
    description: null
    },
    182: {
    id: "182",
    name: "Holborn Group of Companies",
    website: null,
    description: null
    },
    183: {
    id: "183",
    name: "Homesite Developments Inc.",
    website: null,
    description: null
    },
    184: {
    id: "184",
    name: "Homeward Bound Development Inc.",
    website: null,
    description: null
    },
    185: {
    id: "185",
    name: "Homewood Constructors Ltd.",
    website: null,
    description: null
    },
    186: {
    id: "186",
    name: "Honest Living (0875260 BC Ltd)",
    website: null,
    description: null
    },
    187: {
    id: "187",
    name: "Hudson West Development Group",
    website: null,
    description: null
    },
    188: {
    id: "188",
    name: "Hungerford Group",
    website: null,
    description: null
    },
    189: {
    id: "189",
    name: "Hybrid Homes Ltd.,",
    website: null,
    description: null
    },
    190: {
    id: "190",
    name: "Hyland Pacific Holdings Inc",
    website: null,
    description: null
    },
    191: {
    id: "191",
    name: "I4 Property Group",
    website: null,
    description: null
    },
    192: {
    id: "192",
    name: "Ikonik Homes",
    website: null,
    description: null
    },
    193: {
    id: "193",
    name: "Image Development Inc",
    website: null,
    description: null
    },
    194: {
    id: "194",
    name: "IMANI Development Ltd.",
    website: null,
    description: null
    },
    195: {
    id: "195",
    name: "Intergulf Development Group",
    website: null,
    description: null
    },
    196: {
    id: "196",
    name: "Intracorp",
    website: null,
    description: null
    },
    197: {
    id: "197",
    name: "Intrawest Development Corporation",
    website: null,
    description: null
    },
    198: {
    id: "198",
    name: "IPM Development",
    website: null,
    description: null
    },
    199: {
    id: "199",
    name: "IRCA Group",
    website: null,
    description: null
    },
    200: {
    id: "200",
    name: "Island View Construction Ltd.",
    website: null,
    description: null
    },
    201: {
    id: "201",
    name: "Isle of Mann",
    website: null,
    description: null
    },
    202: {
    id: "202",
    name: "Isle of Mann Construction",
    website: null,
    description: null
    },
    203: {
    id: "203",
    name: "Jacken Investment Inc",
    website: null,
    description: null
    },
    204: {
    id: "204",
    name: "Jakin Group of Companies",
    website: null,
    description: null
    },
    205: {
    id: "205",
    name: "James Schouw & Associates",
    website: null,
    description: null
    },
    206: {
    id: "206",
    name: "Jameson Development Corp.",
    website: null,
    description: null
    },
    207: {
    id: "207",
    name: "Janda Group",
    website: null,
    description: null
    },
    208: {
    id: "208",
    name: "Jawl Properties Ltd.",
    website: null,
    description: null
    },
    209: {
    id: "209",
    name: "JCR Construction Ltd",
    website: null,
    description: null
    },
    210: {
    id: "210",
    name: "JDS Properties",
    website: null,
    description: null
    },
    211: {
    id: "211",
    name: "Jeffs Residences Limited Partnership",
    website: null,
    description: null
    },
    212: {
    id: "212",
    name: "Jel Investments and Briland Inc.",
    website: null,
    description: null
    },
    213: {
    id: "213",
    name: "JooHo Development Ltd.",
    website: null,
    description: null
    },
    214: {
    id: "214",
    name: "Jung Developement",
    website: null,
    description: null
    },
    215: {
    id: "215",
    name: "Kang & Gill Construction Ltd.",
    website: null,
    description: null
    },
    216: {
    id: "216",
    name: "Kenstone Properties Ltd.",
    website: null,
    description: null
    },
    217: {
    id: "217",
    name: "Kerkhoff Construction Ltd.",
    website: null,
    description: null
    },
    218: {
    id: "218",
    name: "Kerrisdale Station Ltd",
    website: null,
    description: null
    },
    219: {
    id: "219",
    name: "Kingma Bros. Developments",
    website: null,
    description: null
    },
    220: {
    id: "220",
    name: "KINGSWOOD CAPITAL CORPORATION",
    website: null,
    description: null
    },
    221: {
    id: "221",
    name: "Koolhaus- Abbey Woods Development Ltd.",
    website: null,
    description: null
    },
    222: {
    id: "222",
    name: "Kraftsmen Group of Companies",
    website: null,
    description: null
    },
    223: {
    id: "223",
    name: "Lakewood Management Ltd.",
    website: null,
    description: null
    },
    224: {
    id: "224",
    name: "Landmark Yaletown Projects Inc",
    website: null,
    description: null
    },
    225: {
    id: "225",
    name: "Lanstone Homes",
    website: null,
    description: null
    },
    226: {
    id: "226",
    name: "Larc Development",
    website: null,
    description: null
    },
    227: {
    id: "227",
    name: "Larco Investment Ltd",
    website: null,
    description: null
    },
    228: {
    id: "228",
    name: "LDHT Enterprise Ltd.",
    website: null,
    description: null
    },
    229: {
    id: "229",
    name: "Le Fevre & Company",
    website: null,
    description: null
    },
    230: {
    id: "230",
    name: "Ledcor Properties",
    website: null,
    description: null
    },
    231: {
    id: "231",
    name: "Ledingham McAllister",
    website: null,
    description: null
    },
    232: {
    id: "232",
    name: "Legendary Development",
    website: null,
    description: null
    },
    233: {
    id: "233",
    name: "Liberty Homes Ltd.",
    website: null,
    description: null
    },
    234: {
    id: "234",
    name: "LICO Construction Ltd",
    website: null,
    description: null
    },
    235: {
    id: "235",
    name: "Limona Group",
    website: null,
    description: null
    },
    236: {
    id: "236",
    name: "LionRock Developments",
    website: null,
    description: null
    },
    237: {
    id: "237",
    name: "Listraor Homes",
    website: null,
    description: null
    },
    238: {
    id: "238",
    name: "LPH Development Ltd.",
    website: null,
    description: null
    },
    239: {
    id: "239",
    name: "LRG Group of Companies",
    website: null,
    description: null
    },
    240: {
    id: "240",
    name: "Luxor Home Collection Group",
    website: null,
    description: null
    },
    241: {
    id: "241",
    name: "M. Karton",
    website: null,
    description: null
    },
    242: {
    id: "242",
    name: "MacLean Homes Ltd.",
    website: null,
    description: null
    },
    243: {
    id: "243",
    name: "MacLean Management Ltd.",
    website: null,
    description: null
    },
    244: {
    id: "244",
    name: "Maeda Development Ltd.",
    website: null,
    description: null
    },
    245: {
    id: "245",
    name: "Magellen Developments (20/20) Inc",
    website: null,
    description: null
    },
    246: {
    id: "246",
    name: "Magusta Development",
    website: null,
    description: null
    },
    247: {
    id: "247",
    name: "Mainland Development Ltd",
    website: null,
    description: null
    },
    248: {
    id: "248",
    name: "Manchester Homes Ltd.",
    website: null,
    description: null
    },
    249: {
    id: "249",
    name: "Mann Group",
    website: null,
    description: null
    },
    250: {
    id: "250",
    name: "Manorlane Homes",
    website: null,
    description: null
    },
    251: {
    id: "251",
    name: "Mara Lake Estates",
    website: null,
    description: null
    },
    252: {
    id: "252",
    name: "Marcon",
    website: null,
    description: null
    },
    253: {
    id: "253",
    name: "Matt Gruber Construction Ltd.",
    website: null,
    description: null
    },
    254: {
    id: "254",
    name: "McLaren Housing Society",
    website: null,
    description: null
    },
    255: {
    id: "255",
    name: "McLean Courtenay Development Associates",
    website: null,
    description: null
    },
    256: {
    id: "256",
    name: "Melrose Developments Ltd.",
    website: null,
    description: null
    },
    257: {
    id: "257",
    name: "Michael Williams Development",
    website: null,
    description: null
    },
    258: {
    id: "258",
    name: "Mierau Contractors Ltd.",
    website: null,
    description: null
    },
    259: {
    id: "259",
    name: "Mike Geric Construction Ltd.",
    website: null,
    description: null
    },
    260: {
    id: "260",
    name: "Millennium Development Corporation",
    website: null,
    description: null
    },
    261: {
    id: "261",
    name: "MILLENNIUM GROUP",
    website: null,
    description: null
    },
    262: {
    id: "262",
    name: "Millennium World",
    website: null,
    description: null
    },
    263: {
    id: "263",
    name: "Milori Homes",
    website: null,
    description: null
    },
    264: {
    id: "264",
    name: "Minglian Holding Ltd.",
    website: null,
    description: null
    },
    265: {
    id: "265",
    name: "Minglian Holdings Ltd.",
    website: null,
    description: null
    },
    266: {
    id: "266",
    name: "Miracon",
    website: null,
    description: null
    },
    267: {
    id: "267",
    name: "ML Properties Ltd.",
    website: null,
    description: null
    },
    268: {
    id: "268",
    name: "Mo Yeung International Enterprise Ltd.",
    website: null,
    description: null
    },
    269: {
    id: "269",
    name: "Modern Green Development Co. Ltd",
    website: null,
    description: null
    },
    270: {
    id: "270",
    name: "Molnar Group",
    website: null,
    description: null
    },
    271: {
    id: "271",
    name: "Monaco Estates",
    website: null,
    description: null
    },
    272: {
    id: "272",
    name: "MONDEVO Projects Inc.",
    website: null,
    description: null
    },
    273: {
    id: "273",
    name: "Mosaic Avenue Realty Ltd.",
    website: null,
    description: null
    },
    274: {
    id: "274",
    name: "Mosaic Development",
    website: null,
    description: null
    },
    275: {
    id: "275",
    name: "MOSAIC Homes",
    website: null,
    description: null
    },
    276: {
    id: "276",
    name: "Mount Baker Enterprises Ltd",
    website: null,
    description: null
    },
    277: {
    id: "277",
    name: "Mount Seymour Developments Inc.",
    website: null,
    description: null
    },
    278: {
    id: "278",
    name: "Mountain West Properties Inc.",
    website: null,
    description: null
    },
    279: {
    id: "279",
    name: "N-Vision Properties Inc.",
    website: null,
    description: null
    },
    280: {
    id: "280",
    name: "Narland",
    website: null,
    description: null
    },
    281: {
    id: "281",
    name: "New Valley Holdings",
    website: null,
    description: null
    },
    282: {
    id: "282",
    name: "New World Equities I",
    website: null,
    description: null
    },
    283: {
    id: "283",
    name: "Newgen Group of Companies",
    website: null,
    description: null
    },
    284: {
    id: "284",
    name: "Newmark Group",
    website: null,
    description: null
    },
    285: {
    id: "285",
    name: "Nipro Developments Ltd",
    website: null,
    description: null
    },
    286: {
    id: "286",
    name: "No. 145 Cathedral Ventures Ltd.",
    website: null,
    description: null
    },
    287: {
    id: "287",
    name: "No. 249 Cathedral Ventures Ltd.",
    website: null,
    description: null
    },
    288: {
    id: "288",
    name: "Noel Developments Ltd.",
    website: null,
    description: null
    },
    289: {
    id: "289",
    name: "Noort Homes",
    website: null,
    description: null
    },
    290: {
    id: "290",
    name: "Noran West Development Ltd",
    website: null,
    description: null
    },
    291: {
    id: "291",
    name: "Nordel Construction Ltd.",
    website: null,
    description: null
    },
    292: {
    id: "292",
    name: "Norman Homes Inc.",
    website: null,
    description: null
    },
    293: {
    id: "293",
    name: "North America Homes",
    website: null,
    description: null
    },
    294: {
    id: "294",
    name: "NOW Developments",
    website: null,
    description: null
    },
    295: {
    id: "295",
    name: "Oaklane Homes",
    website: null,
    description: null
    },
    296: {
    id: "296",
    name: "Oakvale Development",
    website: null,
    description: null
    },
    297: {
    id: "297",
    name: "OMICRON",
    website: null,
    description: null
    },
    298: {
    id: "298",
    name: "Omni Pacific Development Corp",
    website: null,
    description: null
    },
    299: {
    id: "299",
    name: "Onni Group",
    website: null,
    description: null
    },
    300: {
    id: "300",
    name: "OPAL",
    website: null,
    description: null
    },
    301: {
    id: "301",
    name: "Open Concept Development Inc.",
    website: null,
    description: null
    },
    302: {
    id: "302",
    name: "Oris Consulting limited",
    website: null,
    description: null
    },
    303: {
    id: "303",
    name: "Osoyoos Shoreline Development Ltd.",
    website: null,
    description: null
    },
    304: {
    id: "304",
    name: "Overture Living",
    website: null,
    description: null
    },
    305: {
    id: "305",
    name: "Oviedo Developments",
    website: null,
    description: null
    },
    306: {
    id: "306",
    name: "Pacific C & B Development Corporation",
    website: null,
    description: null
    },
    307: {
    id: "307",
    name: "Pacific New Technologies",
    website: null,
    description: null
    },
    308: {
    id: "308",
    name: "Palcor",
    website: null,
    description: null
    },
    309: {
    id: "309",
    name: "Palladium",
    website: null,
    description: null
    },
    310: {
    id: "310",
    name: "Pantheon Developments Ltd.",
    website: null,
    description: null
    },
    311: {
    id: "311",
    name: "Panther Construction",
    website: null,
    description: null
    },
    312: {
    id: "312",
    name: "Parkgreen Homes Ltd",
    website: null,
    description: null
    },
    313: {
    id: "313",
    name: "Parklane Homes",
    website: null,
    description: null
    },
    314: {
    id: "314",
    name: "Patterson Development",
    website: null,
    description: null
    },
    315: {
    id: "315",
    name: "Pavilion Homes",
    website: null,
    description: null
    },
    316: {
    id: "316",
    name: "PCI Real Estate Development",
    website: null,
    description: null
    },
    317: {
    id: "317",
    name: "Peace Enterprises Ltd",
    website: null,
    description: null
    },
    318: {
    id: "318",
    name: "Pennyfarthing Development Corp",
    website: null,
    description: null
    },
    319: {
    id: "319",
    name: "Penta Builders Group Inc.",
    website: null,
    description: null
    },
    320: {
    id: "320",
    name: "Peterson Group",
    website: null,
    description: null
    },
    321: {
    id: "321",
    name: "Phileo Development Corp.",
    website: null,
    description: null
    },
    322: {
    id: "322",
    name: "Phoenix Homes",
    website: null,
    description: null
    },
    323: {
    id: "323",
    name: "Pinnacle International",
    website: null,
    description: null
    },
    324: {
    id: "324",
    name: "Pinora Homes Ltd.",
    website: null,
    description: null
    },
    325: {
    id: "325",
    name: "Pioneer Designs Corporation",
    website: null,
    description: null
    },
    326: {
    id: "326",
    name: "Platinum Group of Companies",
    website: null,
    description: null
    },
    327: {
    id: "327",
    name: "Pointe of View Developments",
    website: null,
    description: null
    },
    328: {
    id: "328",
    name: "Polstar Construction",
    website: null,
    description: null
    },
    329: {
    id: "329",
    name: "Polygon",
    website: null,
    description: null
    },
    330: {
    id: "330",
    name: "Polygon Homes",
    website: null,
    description: null
    },
    331: {
    id: "331",
    name: "Polygon Nordel Development Ltd.",
    website: null,
    description: null
    },
    332: {
    id: "332",
    name: "Polygon Realty Ltd.",
    website: null,
    description: null
    },
    333: {
    id: "333",
    name: "Port Capital Group Inc.",
    website: null,
    description: null
    },
    334: {
    id: "334",
    name: "Porte Development Corp.",
    website: null,
    description: null
    },
    335: {
    id: "335",
    name: "Portrait Homes Ltd.",
    website: null,
    description: null
    },
    336: {
    id: "336",
    name: "PR Pomeroy Restoration & Construction",
    website: null,
    description: null
    },
    337: {
    id: "337",
    name: "Premier International Development",
    website: null,
    description: null
    },
    338: {
    id: "338",
    name: "Premier Pacific Developments",
    website: null,
    description: null
    },
    339: {
    id: "339",
    name: "Prima Properties Ltd.",
    website: null,
    description: null
    },
    340: {
    id: "340",
    name: "Prime Tower Ltd.",
    website: null,
    description: null
    },
    341: {
    id: "341",
    name: "Prosper Enterprises",
    website: null,
    description: null
    },
    342: {
    id: "342",
    name: "Quadra Homes",
    website: null,
    description: null
    },
    343: {
    id: "343",
    name: "Qualex-Landmark",
    website: null,
    description: null
    },
    344: {
    id: "344",
    name: "Qualico Development",
    website: null,
    description: null
    },
    345: {
    id: "345",
    name: "Quantum Properties",
    website: null,
    description: null
    },
    346: {
    id: "346",
    name: "Quest Projects Inc",
    website: null,
    description: null
    },
    347: {
    id: "347",
    name: "Quigg",
    website: null,
    description: null
    },
    348: {
    id: "348",
    name: "Quorum Construction",
    website: null,
    description: null
    },
    349: {
    id: "349",
    name: "R.A.R. Holdings Ltd.",
    website: null,
    description: null
    },
    350: {
    id: "350",
    name: "Raicon Developments Inc.",
    website: null,
    description: null
    },
    351: {
    id: "351",
    name: "RBI Construction Group Inc",
    website: null,
    description: null
    },
    352: {
    id: "352",
    name: "RDC Fine Homes",
    website: null,
    description: null
    },
    353: {
    id: "353",
    name: "RDG Management Ltd.",
    website: null,
    description: null
    },
    354: {
    id: "354",
    name: "Redekop Homes Ltd",
    website: null,
    description: null
    },
    355: {
    id: "355",
    name: "Redekop Kroeker Development Inc.",
    website: null,
    description: null
    },
    356: {
    id: "356",
    name: "Regent International Development Ltd",
    website: null,
    description: null
    },
    357: {
    id: "357",
    name: "Reliance Properties Ltd.",
    website: null,
    description: null
    },
    358: {
    id: "358",
    name: "Rempel Development Group Ltd",
    website: null,
    description: null
    },
    359: {
    id: "359",
    name: "Revera Living",
    website: null,
    description: null
    },
    360: {
    id: "360",
    name: "Revolution Developments",
    website: null,
    description: null
    },
    361: {
    id: "361",
    name: "RG Properties",
    website: null,
    description: null
    },
    362: {
    id: "362",
    name: "Richardson Bros. Group",
    website: null,
    description: null
    },
    363: {
    id: "363",
    name: "Rize Alliance Properties Ltd.",
    website: null,
    description: null
    },
    364: {
    id: "364",
    name: "Royal Group City Ventures Ltd.",
    website: null,
    description: null
    },
    365: {
    id: "365",
    name: "Royale Properties Ltd.,",
    website: null,
    description: null
    },
    366: {
    id: "366",
    name: "Rykon Group Ltd.",
    website: null,
    description: null
    },
    367: {
    id: "367",
    name: "Salient Group",
    website: null,
    description: null
    },
    368: {
    id: "368",
    name: "Sandcastle Holdings Ltd",
    website: null,
    description: null
    },
    369: {
    id: "369",
    name: "Sandhill Development Ltd.",
    website: null,
    description: null
    },
    370: {
    id: "370",
    name: "Sant Investments",
    website: null,
    description: null
    },
    371: {
    id: "371",
    name: "Scott Hill Developments",
    website: null,
    description: null
    },
    372: {
    id: "372",
    name: "Seacorp of Companies",
    website: null,
    description: null
    },
    373: {
    id: "373",
    name: "Sequel 138 Development Corp.",
    website: null,
    description: null
    },
    374: {
    id: "374",
    name: "Shato Holdings Ltd.",
    website: null,
    description: null
    },
    375: {
    id: "375",
    name: "Sightline Group",
    website: null,
    description: null
    },
    376: {
    id: "376",
    name: "Sigma Developments Ltd",
    website: null,
    description: null
    },
    377: {
    id: "377",
    name: "Silk Properties",
    website: null,
    description: null
    },
    378: {
    id: "378",
    name: "Sirus Familamiri",
    website: null,
    description: null
    },
    379: {
    id: "379",
    name: "Skov Developments",
    website: null,
    description: null
    },
    380: {
    id: "380",
    name: "SKY REACH DEVELOPMENT LIMITED",
    website: null,
    description: null
    },
    381: {
    id: "381",
    name: "Solterra Group of Companies",
    website: null,
    description: null
    },
    382: {
    id: "382",
    name: "Sonnenberg Home Builders",
    website: null,
    description: null
    },
    383: {
    id: "383",
    name: "SONUS DEVELOPMENTS FERNDALE LTD",
    website: null,
    description: null
    },
    384: {
    id: "384",
    name: "South Street Development Group",
    website: null,
    description: null
    },
    385: {
    id: "385",
    name: "Spade Holdings Ltd.",
    website: null,
    description: null
    },
    386: {
    id: "386",
    name: "Spirit Properties",
    website: null,
    description: null
    },
    387: {
    id: "387",
    name: "Spotlight Developments Ltd.",
    website: null,
    description: null
    },
    388: {
    id: "388",
    name: "Springbank Development Corp.",
    website: null,
    description: null
    },
    389: {
    id: "389",
    name: "Spruceland Homes",
    website: null,
    description: null
    },
    390: {
    id: "390",
    name: "Staburn Property Group",
    website: null,
    description: null
    },
    391: {
    id: "391",
    name: "Statewood Properties Ltd.",
    website: null,
    description: null
    },
    392: {
    id: "392",
    name: "Steve Copp Construction Ltd.",
    website: null,
    description: null
    },
    393: {
    id: "393",
    name: "Steveston Views Development Corporation, H.A. (Tussy) Berg",
    website: null,
    description: null
    },
    394: {
    id: "394",
    name: "Streamline Properties",
    website: null,
    description: null
    },
    395: {
    id: "395",
    name: "StreetSide Developments",
    website: null,
    description: null
    },
    396: {
    id: "396",
    name: "Sunmark Builders",
    website: null,
    description: null
    },
    397: {
    id: "397",
    name: "Sunshine International Holdings Ltd.",
    website: null,
    description: null
    },
    398: {
    id: "398",
    name: "Suraj Home Builders",
    website: null,
    description: null
    },
    399: {
    id: "399",
    name: "Sutton Group Realty Services Ltd.",
    website: null,
    description: null
    },
    400: {
    id: "400",
    name: "SVM Homes",
    website: null,
    description: null
    },
    401: {
    id: "401",
    name: "Synergy Projects Ltd.",
    website: null,
    description: null
    },
    402: {
    id: "402",
    name: "T.J.B.S. Properties Ltd.",
    website: null,
    description: null
    },
    403: {
    id: "403",
    name: "Takaya Developments Ltd.",
    website: null,
    description: null
    },
    404: {
    id: "404",
    name: "Texor Homes Inc.",
    website: null,
    description: null
    },
    405: {
    id: "405",
    name: "The Airey Group",
    website: null,
    description: null
    },
    406: {
    id: "406",
    name: "The Bowra Group Inc.",
    website: null,
    description: null
    },
    407: {
    id: "407",
    name: "The Cape Group",
    website: null,
    description: null
    },
    408: {
    id: "408",
    name: "THE CIRCADIAN GROUP",
    website: null,
    description: null
    },
    409: {
    id: "409",
    name: "The Maskeen Group",
    website: null,
    description: null
    },
    410: {
    id: "410",
    name: "The Mission Group",
    website: null,
    description: null
    },
    411: {
    id: "411",
    name: "The Norwood Group",
    website: null,
    description: null
    },
    412: {
    id: "412",
    name: "The Pioneer Group",
    website: null,
    description: null
    },
    413: {
    id: "413",
    name: "The Salient Group",
    website: null,
    description: null
    },
    414: {
    id: "414",
    name: "The Surelok Group",
    website: null,
    description: null
    },
    415: {
    id: "415",
    name: "The Townline Group of Companies",
    website: null,
    description: null
    },
    416: {
    id: "416",
    name: "The Wall Group of Companies",
    website: null,
    description: null
    },
    417: {
    id: "417",
    name: "Thind Properties Ltd.",
    website: null,
    description: null
    },
    418: {
    id: "418",
    name: "Thomas Ivanore",
    website: null,
    description: null
    },
    419: {
    id: "419",
    name: "Tien Sher Homes",
    website: null,
    description: null
    },
    420: {
    id: "420",
    name: "Townline",
    website: null,
    description: null
    },
    421: {
    id: "421",
    name: "Toyo Developments",
    website: null,
    description: null
    },
    422: {
    id: "422",
    name: "Trafalgar Enterprises Inc",
    website: null,
    description: null
    },
    423: {
    id: "423",
    name: "Treegroup",
    website: null,
    description: null
    },
    424: {
    id: "424",
    name: "Tri Power Developments Ltd",
    website: null,
    description: null
    },
    425: {
    id: "425",
    name: "Tri-R Development Group Inc",
    website: null,
    description: null
    },
    426: {
    id: "426",
    name: "Trico Homes",
    website: null,
    description: null
    },
    427: {
    id: "427",
    name: "Tridecca Development",
    website: null,
    description: null
    },
    428: {
    id: "428",
    name: "Trimount developments",
    website: null,
    description: null
    },
    429: {
    id: "429",
    name: "Triton Ventures Corp.",
    website: null,
    description: null
    },
    430: {
    id: "430",
    name: "Triumph Pacific Properties Inc",
    website: null,
    description: null
    },
    431: {
    id: "431",
    name: "Troika Developments",
    website: null,
    description: null
    },
    432: {
    id: "432",
    name: "Two By Four Developments Ltd.",
    website: null,
    description: null
    },
    433: {
    id: "433",
    name: "UBC Properties Trust (UBCPT)",
    website: null,
    description: null
    },
    434: {
    id: "434",
    name: "Unimet Homes Ltd.",
    website: null,
    description: null
    },
    435: {
    id: "435",
    name: "United Pacific Development (West 10th) Corporation",
    website: null,
    description: null
    },
    436: {
    id: "436",
    name: "United Properties Group of Companies",
    website: null,
    description: null
    },
    437: {
    id: "437",
    name: "United Properties Ltd",
    website: null,
    description: null
    },
    438: {
    id: "438",
    name: "UPA Construction Group of companies",
    website: null,
    description: null
    },
    439: {
    id: "439",
    name: "VALOUR HOMES",
    website: null,
    description: null
    },
    440: {
    id: "440",
    name: "Van Maren Group of Companies",
    website: null,
    description: null
    },
    441: {
    id: "441",
    name: "Van-burn Construction Ltd.",
    website: null,
    description: null
    },
    442: {
    id: "442",
    name: "Vancouver Pacific Development Corporation",
    website: null,
    description: null
    },
    443: {
    id: "443",
    name: "Vanlux Development",
    website: null,
    description: null
    },
    444: {
    id: "444",
    name: "Vanview Construction",
    website: null,
    description: null
    },
    445: {
    id: "445",
    name: "Vedder Ridge Construction",
    website: null,
    description: null
    },
    446: {
    id: "446",
    name: "Vesta",
    website: null,
    description: null
    },
    447: {
    id: "447",
    name: "Victoria Construction",
    website: null,
    description: null
    },
    448: {
    id: "448",
    name: "Vinterra Properties Inc.",
    website: null,
    description: null
    },
    449: {
    id: "449",
    name: "Voth Bros Developments Ltd",
    website: null,
    description: null
    },
    450: {
    id: "450",
    name: "Walker Hospitality",
    website: null,
    description: null
    },
    451: {
    id: "451",
    name: "Wall Centre False Creek Limited Partnership",
    website: null,
    description: null
    },
    452: {
    id: "452",
    name: "Wall Financial Corporation",
    website: null,
    description: null
    },
    453: {
    id: "453",
    name: "Wallmark Homes",
    website: null,
    description: null
    },
    454: {
    id: "454",
    name: "Wanson Development",
    website: null,
    description: null
    },
    455: {
    id: "455",
    name: "Wanson Peninsula Dev. Ltd.",
    website: null,
    description: null
    },
    456: {
    id: "456",
    name: "Wave Development",
    website: null,
    description: null
    },
    457: {
    id: "457",
    name: "Wertman Development Corporation Invesments Ltd.",
    website: null,
    description: null
    },
    458: {
    id: "458",
    name: "Wesbild",
    website: null,
    description: null
    },
    459: {
    id: "459",
    name: "Wesgroup",
    website: null,
    description: null
    },
    460: {
    id: "460",
    name: "Westbank Projects Corp",
    website: null,
    description: null
    },
    461: {
    id: "461",
    name: "Western Canadian Properties Group",
    website: null,
    description: null
    },
    462: {
    id: "462",
    name: "Western Construstion",
    website: null,
    description: null
    },
    463: {
    id: "463",
    name: "Westmark Development Group",
    website: null,
    description: null
    },
    464: {
    id: "464",
    name: "WestStone",
    website: null,
    description: null
    },
    465: {
    id: "465",
    name: "Woodbridge Properties",
    website: null,
    description: null
    },
    466: {
    id: "466",
    name: "YUANHENG HOLDINGS LTD.",
    website: null,
    description: null
    },
    467: {
    id: "467",
    name: "Zenith Development Croup",
    website: null,
    description: null
    },
    468: {
    id: "468",
    name: "Zenterra Developments",
    website: null,
    description: null
    },
    469: {
    id: "469",
    name: "Info Not Yet Available",
    website: null,
    description: "Info Not Yet Available"
    },
    470: {
    id: 470,
    name: "GMC Projects Inc",
    website: "https://www.gmcprojects.com/",
    description: null
    },
    471: {
    id: 471,
    name: "Anthem Properties",
    website: "https://anthemproperties.com/",
    description: null
    },
    472: {
    id: 472,
    name: "Redbrick Properties Inc",
    website: "https://redbrickproperties.ca/",
    description: null
    }
  }
}

module.exports = building_developers
